/**
 * Galerie produit épinglée : blocage immédiat, sans glissement préalable.
 *
 * Le thème épingle la galerie avec `top: calc(var(--header-height, 0px) + var(--padding-md))`.
 * Deux problèmes :
 *   1. `--header-height` n'est déclarée que sur l'en-tête lui-même, qui n'est pas
 *      un ancêtre de la section produit. Dans la section, la variable retombe donc
 *      sur son défaut `0px` et la galerie se bloque à 16px du haut de la fenêtre,
 *      c'est à dire SOUS l'en-tête, qui en occupe 80.
 *   2. Une sticky ne se bloque qu'une fois arrivée à cette hauteur. Il faut donc
 *      faire défiler toute la distance qui l'en sépare avant qu'elle ne se fige :
 *      c'est le « petit scroll » avant blocage.
 *
 * Correction : on mesure la position naturelle de la galerie et on cale `top`
 * dessus. Le seuil de blocage coïncide alors avec sa position de départ : elle est
 * figée dès le premier pixel de défilement, sans jamais passer sous l'en-tête.
 *
 * Deux garde-fous :
 *   - jamais plus haut que l'en-tête (sinon elle disparaît derrière) ;
 *   - jamais si bas que le bas de la galerie sorte de l'écran : sur un portable,
 *     mieux vaut un léger glissement que des vignettes coupées.
 */
(function () {
  'use strict';

  if (window.__zoemassStickyGallery) return;
  window.__zoemassStickyGallery = true;

  var GAP = 16;
  var DESKTOP = '(width > 750px)';

  function headerHeight() {
    var header = document.querySelector('.header--sticky');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function apply() {
    document.querySelectorAll('.product-section__medias--sticky').forEach(function (gallery) {
      // Sous 750px la galerie n'est plus épinglée : on rend la main au thème.
      if (!window.matchMedia(DESKTOP).matches) {
        gallery.style.removeProperty('top');
        return;
      }

      var content = gallery.closest('.product-section__content');
      if (!content) return;

      // On mesure sur le conteneur, jamais sur la galerie : une fois bloquée,
      // sa position à l'écran ne dit plus rien de sa position naturelle.
      var padding = parseFloat(window.getComputedStyle(content).paddingTop) || 0;
      var natural = content.getBoundingClientRect().top + window.scrollY + padding;

      var floor = headerHeight() + GAP;
      var ceiling = Math.max(floor, window.innerHeight - gallery.getBoundingClientRect().height - GAP);

      gallery.style.top = Math.min(Math.max(natural, floor), ceiling) + 'px';
    });
  }

  function schedule() {
    window.requestAnimationFrame(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // La hauteur de la galerie n'est fiable qu'une fois les images arrivées.
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
